import React, { useState } from "react";
import {
	Button,
	Dialog,
	DialogActions,
	DialogTitle,
	DialogContent,
	DialogContentText,
	TextField,
	TableCell,
	TableRow,
	TableBody,
	Table,
	FormControlLabel,
	Checkbox,
	FormGroup
} from "@material-ui/core";
import { useHistory } from "react-router-dom";
import GetAppIcon from "@material-ui/icons/GetApp";
import HelpIcon from "@material-ui/icons/Help";
import { toast } from "react-toastify";
import { useStore } from "@store/store";
import closeIcon from "@assets/images/close.svg";
import UploadImage from "@assets/images/blue-upload.svg";
import {
	IMPORT_CUSTOMER_CSV,
	IMPORT_CUSTOMER_CSV_SUCCESS,
	IMPORT_CUSTOMER_CSV_FAILURE,
} from "@utils/actionTypes";
import API from "@services/axios";
import { UploadFile } from "@utils/commonFunctions";
import { fuelSurchargeUpdateStyle } from "./style";
import ErrorListFuelSurchargePopup from "./popup";
import { routes } from "@utils/constant";

function FuelSurchargeUpdate() {
	const history = useHistory();
	const classes = fuelSurchargeUpdateStyle();
	const [open, setOpen] = useState(false);
	const [fileName, setFilename] = useState("");
	const [helpOpen, setHelpOpen] = useState(false);
	const [errorData, setErrorData] = useState([]);
	const [showBtnListErrors, setShowBtnListErrors] = useState(false);
	const [openErrorList, setOpenErrorList] = useState(false);
	const [, dispatch] = useStore();
	const [selected, setSelected] = useState("monthly");

	const handleClickOpen = () => {
		setOpen(true);
	};
	const handleClose = () => {
		setOpen(false);
    setShowBtnListErrors(false);
	};

	const handleCloseErrorList = () => {
		setOpenErrorList(false);
	};

	//Uploading file for importing CSV of truck
	function uploadFile(event, fileName, defaultText) {
		// setOpen(false);
		setFilename(event.target?.files[0]?.name);
		if (event.target.files && event.target.files.length) {
			dispatch({ type: IMPORT_CUSTOMER_CSV });
		}
		UploadFile(event, fileName, defaultText, "text/csv", "customer-awb-csv")
			.then((res) => {
				API.post(`customers/import`, {
					file: res.data.fileName,
					isMonthly: selected === "monthly" ? true : false
				})
					.then((response) => {
						const resData = response?.data;
						if (resData?.code === 200) {
							if (Array.isArray(resData?.data) && resData?.data.length > 0) {
								setErrorData(response?.data?.data);
								setShowBtnListErrors(true);
								dispatch({ type: IMPORT_CUSTOMER_CSV_FAILURE, payload: response?.data?.data });
							} else {
								setShowBtnListErrors(false);
								toast.success(response?.data?.message);
								if (resData?.data === true) {
									history.push(routes.backDatedEvents);
								} else if (selected === "monthly") {
									history.push(routes.monthlyRateUpdates);
								}
								dispatch({
									type: IMPORT_CUSTOMER_CSV_SUCCESS,
									payload: response?.data?.data,
								});
							}
						}
						setFilename("");
						event.target.value = "";
					})
					.catch((error) => {
            setFilename("");
            event.target.value = "";

            if (error.response.data?.message) {
              toast.error(error.response.data?.message);
            } else {
              toast.error("Upload failed. Please check the file format.");
            }
						dispatch({ type: IMPORT_CUSTOMER_CSV_FAILURE, payload: error });
					});
			})
			.catch((error) => {
				setFilename("");
				event.target.value = "";
				dispatch({ type: IMPORT_CUSTOMER_CSV_FAILURE, payload: error });
				toast.error(error.response.data?.message);
			});
	}

	const saveFile = () => {
		window.open(process.env.REACT_APP_FUEL_SURCHARGE_SAMPLE, "_blank")
	};

	return (
		<div className={classes.fuelSurchargeUpdateWrapper}>
			<Button
				className="blue-btn primary-btn"
				color="inherit"
				disableElevation
				onClick={handleClickOpen}
			>
				Fuel Surcharge Update
			</Button>

			<div className={classes.ConfirmWrapper}>
				<Dialog
					open={open}
					// scroll={scroll}
					aria-labelledby="alert-dialog-title"
					aria-describedby="alert-dialog-description"
					className={classes.customModal}
				>
					<div className="close-modal">
						<img src={closeIcon} alt="Close" onClick={handleClose} />
					</div>
					<DialogTitle id="alert-dialog-title" className="title">
						Fuel Surcharge Update
					</DialogTitle>
					<DialogContent>
						<div className="btn-wrapper">
							<div className={classes.fileInput}>
								<TextField
									id="truckCsv"
									variant="outlined"
									type="file"
									onChange={(e) => uploadFile(e, "file-name", "Import csv")}
									InputProps={{
										inputProps: { accept: ".csv" },
									}}
								/>
								<div className="label-block">
									<img src={UploadImage} alt="Upload" />
									<span className="file-name" id="file-name">
										{fileName ? fileName : "Bulk Import"}
									</span>
								</div>
							</div>
						</div>
						<FormGroup className="checkbox-group">
							<FormControlLabel
								control={
									<Checkbox
										checked={selected === "monthly"}
										onChange={() => setSelected("monthly")}
										value="monthly"
									/>
								}
								label="Monthly Rate Update"
							/>
							<FormControlLabel
								control={
									<Checkbox
										checked={selected === "adhoc"}
										onChange={() => setSelected("adhoc")}
										value="adhoc"
									/>
								}
								label="Ad-hoc Rate Change"
							/>
						</FormGroup>
					</DialogContent>
          {showBtnListErrors && (
            <span
              className={classes.customTextLink}
              color="inherit"
              onClick={() => setOpenErrorList(true)}
            >
              View Upload Errors
            </span>
          )}
          <DialogActions>
						<div className={classes.searchWrapper1}>
							<div className="btn-wrapper">
								<div className="form-gourp">
									<Button
										className="orange-btn primary-btn"
										color="inherit"
										disableElevation
										onClick={() => saveFile()}
										startIcon={<GetAppIcon />}
										style={{ width: "190px" }}
									>
										Sample CSV
									</Button>
								</div>
							</div>
							<div className="btn-wrapper">
								<div className="form-gourp">
									<Button
										className="orange-btn primary-btn"
										color="inherit"
										disableElevation
										startIcon={<HelpIcon />}
										onClick={() => setHelpOpen(true)}
									>
										Help
									</Button>
								</div>
							</div>
						</div>
					</DialogActions>
				</Dialog>
				<Dialog open={helpOpen} className={classes.customHelpModal}>
					<div className="close-modal">
						<img
							src={closeIcon}
							alt="Close"
							onClick={() => setHelpOpen(false)}
						/>
					</div>
					<DialogTitle>Bulk Fuel Surcharge Update Instruction</DialogTitle>
					<DialogContent>
						<DialogContentText className={classes.dialogContentText}>
							Please download the sample bulk update fuel surcharge csv file,
							fill out the details, save the file, then use the “BULK IMPORT”
							feature to upload.
						</DialogContentText>

						<DialogContentText className={classes.dialogContentText}>
							Note: If upload is failed, please check the required format for
							City, Customer and Fuel Surcharge.
						</DialogContentText>

						<Table>
							<TableBody>
								<TableRow>
									<TableCell className={classes.cellHeader}>City:</TableCell>
									<TableCell>City Name</TableCell>
								</TableRow>
								<TableRow>
									<TableCell className={classes.cellHeader}>
										Customer:
									</TableCell>
									<TableCell>Customer Name</TableCell>
								</TableRow>
								<TableRow>
									<TableCell className={classes.cellHeader}>
										Fuel Surcharge:
									</TableCell>
									<TableCell>Customer Fuel Surcharge</TableCell>
								</TableRow>
								<TableRow>
									<TableCell className={classes.cellHeader}>
										Start Date:
									</TableCell>
									<TableCell>The day to apply the fuel Surcharge to jobs and invoices</TableCell>
								</TableRow>
							</TableBody>
						</Table>
						<DialogContentText>
							<span className={classes.noteText}>* Monthly Rate Update: </span>
							The system will automatically recalculate all impacted jobs and invoices based on the effective dates within the file.
						</DialogContentText>
						<DialogContentText>
							<span className={classes.noteText}>* Ad-hoc Rate Change: </span>
							Choose this option for exceptional, mid-month rate changes or corrections for specific customers. This will trigger the standard back-dated review workflow.
						</DialogContentText>
					</DialogContent>
				</Dialog>
			</div>

			<ErrorListFuelSurchargePopup
				data={errorData}
				open={openErrorList}
				handleClose={handleCloseErrorList}
			>
			</ErrorListFuelSurchargePopup>
		</div>
	);
}

export default FuelSurchargeUpdate;
